import * as ActionTypes from '../actions/ProductActions';

const initialState = {
  offers: [],
};

const storeOffers = (state = initialState, action) => {
  switch (action.type) {
    case ActionTypes.PROFILE_REQUEST:
      return {
        ...state,
        isFetching: true,
        isFetched: false,
      };

    case ActionTypes.PROFILE_REQUEST_SUCCESS: {
      const offerDetails = action.response.offerDetails.map(( offer, i ) => {
        return {
          ...offer,
          isCopyLink: false,
          id: `offer_${i}`,
        };
      });

      return {
        ...state,
        isFetched: true,
        isFetching: false,
        offers: offerDetails,
      };
    }

    case ActionTypes.PROFILE_REQUEST_FAILURE:
      return state;

    default:
      return state;
  }
};

export default storeOffers;



// WEBPACK FOOTER //
// ./src/product/reducers/StoreOffersReducers.js